import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import AlertDialog from 'components/UI/AlertDialog';
import { FollowUpConfig } from 'services/types/followUpConfig';

import HandleFile from './components/handleFile';
import SelectOrCreateFollowUp from './selectOrCreateFollowUp';

const Campaigns = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const queryBusinessUnitId = queryParams.get('businessUnitId');
  const parsedBusinessUnitId = parseInt(queryBusinessUnitId || '', 10);

  const [businessUnitId, setBusinessUnitId] = useState<number | null>(
    Number.isNaN(parsedBusinessUnitId) ? null : parsedBusinessUnitId
  );
  const [step, setStep] = useState(1);
  const [followUpSuccessAlert, setFollowUpSuccessAlert] = useState(false);
  const [clientUploadSuccessAlert, setClientUploadSuccessAlert] = useState(false);
  const [selectedFollowUp, setSelectedFollowUp] = useState<FollowUpConfig | null>(null);

  useEffect(() => {
    if (selectedFollowUp) {
      setStep(2);
    }
  }, [selectedFollowUp]);

  return (
    <Box pl={2} py={2}>
      <AlertDialog
        openDialog={followUpSuccessAlert}
        setOpenDialog={setFollowUpSuccessAlert}
        header="Follow up creado!"
        msg="Follow up fue creado correctamente"
        cancelMsg="Cerrar"
      />
      <AlertDialog
        openDialog={clientUploadSuccessAlert}
        setOpenDialog={setClientUploadSuccessAlert}
        header="Clientes subidos!"
        msg="Clientes fueron subidos correctamente"
        cancelMsg="Cerrar"
      />
      <Box display="flex" justifyContent="flex-start" mb={2} alignItems="center" pt={1}>
        <Typography variant="h3" pl={2}>
          Campañas
        </Typography>
      </Box>

      {step === 1 && (
        <SelectOrCreateFollowUp
          businessUnitId={businessUnitId}
          setBusinessUnitId={setBusinessUnitId}
          selectFollowUp={setSelectedFollowUp}
        />
      )}
      {step === 2 && businessUnitId && selectedFollowUp && (
        <HandleFile
          businessUnitId={businessUnitId}
          outboundCampaignId={selectedFollowUp.identifier}
          onSuccess={() => setStep(1)}
        />
      )}
    </Box>
  );
};

export default Campaigns;
